import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectStateData } from 'src/core/redux/selectors';
import { REMAINDERS_NAMESPACE } from 'src/constants/forms';

import RemaindersDetailsComponent from './RemaindersDetailsComponent';

const RemaindersDetailsContainer = ({ details, plateSize, visible }) => (
  <RemaindersDetailsComponent
    {...{
      details,
      plateSize,
      visible,
    }}
  />
);

RemaindersDetailsContainer.propTypes = {
  details: PropTypes.object,
  plateSize: PropTypes.string,
  visible: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  details: selectStateData(REMAINDERS_NAMESPACE)(state),
});

export default connect(mapStateToProps)(RemaindersDetailsContainer);
